import { useCallback, useState } from "react";
import GatheringUserVariant from "src/api/graphql/__generated__/enums/GatheringUserVariant";
import GatheringFilterSortCard from "../../components/GatheringFilterSortCard";
import GatheringFilterSortSeeAll from "../../components/GatheringFilterSortSeeAll";
import useGatheringFilterSortStore from "../../hooks/useGatheringFilterSortStore";
import useGatheringUsersForFilter, {
	UseGatheringAndUsersForFilterModal_User,
} from "../../hooks/useGatheringUsersForFilter";
import GatheringFilterSortAllUploadersToggle from "./components/GatheringFilterSortAllUploadersToggle";

const GatheringFilterSortAllUploaders = () => {
	const gatheringId = useGatheringFilterSortStore((state) => state.gatheringId);
	const toggleFilterUploaderId = useGatheringFilterSortStore(
		(state) => state.toggleFilterUploaderId,
	);
	const [searchInput, setSearchInput] = useState("");

	const { fetchMore, gathering, refresh, refreshing, loading } = useGatheringUsersForFilter(
		gatheringId,
		{ search: searchInput, variant: GatheringUserVariant.Uploader },
	);

	const renderItem = useCallback(
		({ item }: { item: UseGatheringAndUsersForFilterModal_User }) => {
			return (
				<GatheringFilterSortCard
					text={`${item.firstName ?? ""} ${item.lastName ?? ""}`}
					imageSrc={item.profilePicture?.url ?? undefined}
					hasFallbackImage={true}
					renderSelector={() => (
						<GatheringFilterSortAllUploadersToggle userId={item.userId} />
					)}
					onPress={() => toggleFilterUploaderId(item.userId)}
				/>
			);
		},
		[toggleFilterUploaderId],
	);

	return (
		<GatheringFilterSortSeeAll
			testID="FilterSortAllUploaders"
			headerText="Uploaders"
			users={gathering?.users?.payload ?? []}
			renderItem={renderItem}
			handleSearchInput={setSearchInput}
			onEndReached={fetchMore}
			onRefresh={refresh}
			refreshing={refreshing}
			loading={loading}
		/>
	);
};

export default GatheringFilterSortAllUploaders;
